import type { FC, ReactNode } from "react";

export const PanelSubtitle: FC<{
  children: ReactNode;
}> = ({ children }) => <div className="text-slate-600">{children}</div>;
